import { ClipboardAction } from "@circleco/compass/components/ClipboardAction";
import { TextInput } from "@circleco/compass/components/TextInput";

interface ShareLinkFieldProps {
  value?: string;
}

export const ShareLinkField = ({ value = "" }: ShareLinkFieldProps) => (
  <TextInput
    readOnly
    readonly
    value={value}
    endContent={<ClipboardAction value={value} />}
  />
);
